import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Welcome from "./pages/Welcome/Welcome.jsx";
import NotFound from "./pages/NotFound/NotFound";
import Devalls from "./pages/Devalls/Devalls.jsx";
import LegalNotice from "./pages/LegalNotice/LegaleNotice.jsx";
import PrivacyPolicy from "./pages/Politique/Politique.jsx";
import CookiesPolicy from "./pages/Politique/CookiePolicy.jsx";
import CookieConsent from "./components/Cookies/Cookies.jsx";

const Layout = ({ children }) => {
  const location = useLocation();

  // Condition pour cacher à la fois le Header et le Footer sur la page d'accueil
  const hideHeaderFooter = location.pathname === "/"; // Cache le Header et le Footer uniquement sur "/"

  // Condition pour cacher seulement le Header sur les pages spécifiques
  const hideHeader =
    location.pathname === "/legalnotices" ||
    location.pathname === "/privacypolicy" ||
    location.pathname === "/cookiespolicy"; // Cacher seulement le Header sur ces pages

  return (
    <>
      {/* Affiche Header uniquement si hideHeaderFooter est false */}
      {!hideHeaderFooter && !hideHeader && <Header />}
      {children}
      {/* Affiche Footer uniquement si hideHeaderFooter est false */}
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Layout>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Welcome />} />
          <Route path="/devalls" element={<Devalls />} />
          <Route path="/legalnotices" element={<LegalNotice />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/cookiespolicy" element={<CookiesPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Analytics />
    </Router>
  );
};

export default App;
